import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Accessor.js";
import r from "../../core/Evented.js";
import { HandleOwnerMixin as s } from "../../core/HandleOwner.js";
import { IdentifiableMixin as i } from "../../core/Identifiable.js";
import o from "../../core/Logger.js";
import { unwrapOr as l } from "../../core/maybe.js";
import { EsriPromiseMixin as n } from "../../core/Promise.js";
import { property as a } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as p } from "../../core/accessorSupport/decorators/subclass.js";

var d = /*#__PURE__*/function (_s) {
  _inherits(d, _s);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this.layer = null, _this.parent = null;
    return _this;
  }

  _createClass(d, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.when().catch(function (e) {
        if ("layerview:create-error" !== e.name) {
          var _t = _this2.layer && _this2.layer.id || "no id",
              _r = _this2.layer && _this2.layer.title || "no title";

          throw o.getLogger(_this2.declaredClass).error("#resolve()", "Failed to resolve layer view (layer title: '".concat(_r, "', id: '").concat(_t, "')"), e), e;
        }
      });
    }
  }, {
    key: "fullOpacity",
    get: function get() {
      return l(this.get("layer.opacity"), 1) * l(this.get("parent.fullOpacity"), 1);
    }
  }, {
    key: "suspended",
    get: function get() {
      return !this.canResume();
    }
  }, {
    key: "suspendInfo",
    get: function get() {
      return this.getSuspendInfo();
    }
  }, {
    key: "legendEnabled",
    get: function get() {
      return !this.suspended && !0 === this.layer.legendEnabled;
    }
  }, {
    key: "updating",
    get: function get() {
      return !!(this.updatingHandles && this.updatingHandles.updating || this.isUpdating());
    }
  }, {
    key: "updatingProgress",
    get: function get() {
      return this.updating ? 0 : 1;
    }
  }, {
    key: "visible",
    get: function get() {
      var e;
      return !0 === (null == (e = this.layer) ? void 0 : e.visible);
    },
    set: function set(e) {
      void 0 !== e ? this._override("visible", e) : this._clearOverride("visible");
    }
  }, {
    key: "canResume",
    value: function canResume() {
      return !this.get("parent.suspended") && this.get("view.ready") && this.get("layer.loaded") && this.visible || !1;
    }
  }, {
    key: "getSuspendInfo",
    value: function getSuspendInfo() {
      var e = this.parent && this.parent.suspended ? this.parent.suspendInfo : {},
          t = this;
      return t.view && t.view.ready || (e.viewNotReady = !0), this.layer && this.layer.loaded || (e.layerNotLoaded = !0), this.visible || (e.layerInvisible = !0), e;
    }
  }, {
    key: "isUpdating",
    value: function isUpdating() {
      return !1;
    }
  }]);

  return d;
}(s(i(n(r.EventedMixin(t)))));

e([a()], d.prototype, "fullOpacity", null), e([a()], d.prototype, "layer", void 0), e([a()], d.prototype, "parent", void 0), e([a({
  readOnly: !0
})], d.prototype, "suspended", null), e([a({
  readOnly: !0
})], d.prototype, "suspendInfo", null), e([a({
  readOnly: !0
})], d.prototype, "legendEnabled", null), e([a({
  type: Boolean,
  readOnly: !0
})], d.prototype, "updating", null), e([a({
  readOnly: !0
})], d.prototype, "updatingProgress", null), e([a()], d.prototype, "visible", null), d = e([p("esri.views.layers.LayerView")], d);
var u = d;
export { u as default };